import { useQuery } from '@tanstack/react-query';
import { getAllClients } from '../../../../services/tickets/admin';

export const clientsQueryKeys = {
  all: ['adminClients'],
};

const normalizeClients = (response) => {
  const list = response?.clients ?? response?.data ?? (Array.isArray(response) ? response : []);
  return list.map((client) => ({
    id: client._id ?? client.id,
    name: client.name ?? client.clientName ?? 'Unnamed client',
  }));
};

export function useClientsQuery() {
  return useQuery({
    queryKey: clientsQueryKeys.all,
    queryFn: getAllClients,
    select: normalizeClients,
    staleTime: 60_000, // 1min cache time
  });
}
